export var FormType;
(function (FormType) {
    FormType["Users"] = "users";
    FormType["Groups"] = "groups";
})(FormType || (FormType = {}));
//# sourceMappingURL=FormType.js.map